import * as React from 'react';
import { connect } from 'react-redux';
import styled from '../../theme/styled-components';
import { FlexCol, FlexRow, Loader } from 'eshop-defaults';
import { rem } from 'polished';
import Breadcrumbs from '../../components/_helpers/Breadcrumbs/Breadcrumbs';
import { __, __r } from 'react-i18n';
import {
  BreadCrumbType,
  setBreadCrumbPath,
} from '../BreadCrumb/breadCrumbSlice';
import { H1Wrapper } from '../../components/_helpers/Heading/Heading';
import {
  loadcomparisonProductsData,
  loadcomparisonProductsDataFromProductPlus,
  resetProductsData,
} from './comparisonSlice';
import { addItemToCart, setAddToCartModalVisibility } from '../Cart/cartSlice';
import Input, {
  InputDefault,
} from '../../components/_helpers/forms/Input/Input';
import { resolveBaseUrlByLang } from '../../configureTrans';
import { ComparisonAttribsDataItem } from 'eshop-defaults';
import { Comparison } from 'eshop-defaults';
import { CompareService } from 'eshop-defaults';

interface Props {
  dispatch: any;
  products: any[];
  sharedProducts: any[];
  attribsData: ComparisonAttribsDataItem[];
  isFetching: boolean;
  location: any;
  lang: string;
  hostname: string;
}

function ComparisonContainer({
  dispatch,
  products,
  sharedProducts,
  attribsData,
  isFetching,
  location,
  lang,
  hostname,
}: Props) {
  const [shareMode, setShareMode] = React.useState(false);

  React.useEffect(() => {
    dispatch(setBreadCrumbPath(BreadCrumbType.COMPARISON));
    if (location.query.s !== undefined) {
      setShareMode(true);
      dispatch(
        loadcomparisonProductsDataFromProductPlus(
          location.query.s.split(';'),
          true,
        ),
      );
    } else {
      const compareService = new CompareService();
      dispatch(
        loadcomparisonProductsData(
          compareService.getCompareProductIds(),
          false,
        ),
      );
    }
  }, [dispatch]);

  React.useEffect(() => {}, [products]);

  const onProductRemove = (id: number) => {
    if (shareMode) {
      if (window) {
        const params = new URLSearchParams(window.location.search);
        let productPlus = params.get('s')?.split(';') || [];

        const productPlu = products?.find(product => product.product_id === id)
          ?.product_plu;

        console.log({ productPlu });
        if (productPlu) {
          productPlus = productPlus.filter(item => item !== productPlu);

          console.log({ updatedProductPlus: productPlus });

          dispatch(
            loadcomparisonProductsDataFromProductPlus(productPlus, shareMode),
          );
          if (window) {
            const url = new URL(window.location.href);
            url.searchParams.set('s', productPlus.join(';'));
            window.history.pushState({}, '', url);
          }
        }
      }
    } else {
      const compareService = new CompareService();
      const productIds = compareService.removeProductToCompare(id);

      if (productIds.length) {
        dispatch(loadcomparisonProductsData(productIds, shareMode));
      } else {
        dispatch(resetProductsData());
      }
    }
  };

  const handleAddToCart = async (product: any, count: number) => {
    if (count > 0) {
      await dispatch(addItemToCart(product, count, false, true));
    } else {
      await dispatch(setAddToCartModalVisibility(false, product));
    }
  };

  const resetAll = () => {
    const compareService = new CompareService();
    compareService.removeAll();
    dispatch(resetProductsData());
  };

  const onShareFocus = e => {
    e.target.select();
  };

  const cProducts = shareMode ? sharedProducts : products;

  return (
    <Loader loading={isFetching}>
      <Wrapper className="container container--wide">
        <ContentWrapper>
          <TitleBarWrapper>
            <Title> {__('Porovnanie produktov')} </Title>
            {cProducts?.length ? (
              <ShareInput
                name="share"
                value={`${resolveBaseUrlByLang(hostname, lang, true)}${__r(
                  'routes:porovnanie',
                  '/porovnanie',
                )}?s=${cProducts
                  ?.map(product => product.product_plu)
                  .join(';')}`}
                onFocus={e => onShareFocus(e)}
              />
            ) : (
              <></>
            )}
          </TitleBarWrapper>
          {cProducts?.length ? (
            <Comparison
              products={cProducts}
              attribsData={attribsData}
              onProductRemove={onProductRemove}
              resetAll={resetAll}
              addToCart={handleAddToCart}
              shareMode={shareMode}
            />
          ) : (
            <div> {__('Nemáte žiadne produkty na porovnanie')} </div>
          )}
        </ContentWrapper>
      </Wrapper>
    </Loader>
  );
}

const Wrapper = styled(FlexRow)`
  width: 100%;
  padding: 0;
  padding-left: ${rem(32)};
  padding-right: ${rem(32)};

  ${({ theme }) => theme.mediab.l925`
    flex-flow: column;
    padding: 0;
  `}
`;

const ContentWrapper = styled(FlexCol)`
  width: 100%;
  justify-content: flex-end;
  margin-bottom: ${rem(80)};
  ${({ theme }) => theme.mediab.l925`
     justify-content: center;
  `}
`;

const Title = styled.h1`
  font-weight: 400;
  font-size: ${rem(30)};
  line-height: ${rem(38)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-bottom: ${rem(25)};

  ${({ theme }) => theme.mediab.l925`
    margin: ${rem(15)} 0;
    font-size: ${rem(24)};
    line-height: ${rem(32)};
  `}
`;

const TitleBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${({ theme }) => theme.mediab.l925`
    flex-direction: column;
    margin-bottom: ${rem(15)};
  `}
`;

const ShareInput = styled(InputDefault)`
  background: url('/assets/dsi/share.svg') no-repeat;
  background-position: ${rem(5)} ${rem(8)};
  padding-left: ${rem(35)};
`;

const mapStateToProps = state => {
  return {
    lang: state.general.lang,
    products: state.comparison?.products,
    sharedProducts: state.comparison?.sharedProducts,
    attribsData: state.comparison?.attribsData,
    isFetching: state.comparison?.isFetching,
  };
};

export default connect(mapStateToProps)(ComparisonContainer);
